import { NotificationManager } from "react-notifications";

const obj = {
  normal: (m) => {
    return NotificationManager.error(m, null, 3000);
  },
};

export default obj;
